import { Button, EmptyState, Icon } from "@elit-hair/elit-ui";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TbCalendarPlus, TbCalendarTime } from "react-icons/tb";

import { PageActions } from "@/components/page-actions";
import { AdminSurface } from "@/components/ui/admin-surface";
import { EventRulesTable } from "@/pages/events/$id/rules/components/event-rules-table";
import { APP_ROUTES_FULL } from "@/utils/routes";

import { EventRuleActionDialog } from "./components/event-rule-action-dialog";

export const Route = createFileRoute(APP_ROUTES_FULL.EVENT_RULES)({
    component: ManagementEventRules,
});

function ManagementEventRules() {
    const { id: eventTypeId } = Route.useParams();
    const { t } = useTranslation();
    const [openDialog, setOpenDialog] = useState(false);

    if (!eventTypeId) {
        return (
            <AdminSurface className="p-8">
                <EmptyState
                    variant="simple"
                    icon={<TbCalendarTime size={40} className="text-muted-foreground" />}
                    title="no_events_found"
                />
            </AdminSurface>
        );
    }

    return (
        <div className="flex flex-col gap-4">
            <PageActions>
                <Button onClick={() => setOpenDialog(true)}>
                    <Icon icon={TbCalendarPlus} />
                    {t("new_event_rule")}
                </Button>
            </PageActions>

            <div className="flex-1 overflow-auto">
                <EventRulesTable eventTypeId={eventTypeId} />
            </div>

            <EventRuleActionDialog eventTypeId={eventTypeId} open={openDialog} onOpenChange={setOpenDialog} />
        </div>
    );
}
